var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [
        _vm._v(" About " + _vm._s(_vm.starterSite.website_name) + " ")
      ]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("p", [
                    _vm._v(
                      " In a few short sentences, tell us about your business, goal(s) for your website, target audience, and any other information you think will be useful for building your website. "
                    )
                  ]),
                  _c("v-textarea", {
                    staticClass: "gg-input",
                    attrs: {
                      outlined: "",
                      dense: "",
                      rows: "4"
                    },
                    model: {
                      value: _vm.about,
                      callback: function callback($$v) {
                        _vm.about = $$v
                      },
                      expression: "about"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }